module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_vm._m(0), _vm._v(" "), _c('component-footer')], 1)])])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-6"
  }, [_c('h3', [_vm._v("Listings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "statusbox"
  }, [_c('h2', {
    staticStyle: {
      "text-transform": "inherit"
    }
  }, [_vm._v("CNpros")]), _vm._v(" "), _c('div', {
    staticClass: "statusbox-content"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "cnpro-accounts"
    }
  }, [_c('strong', [_vm._v("view")]), _vm._v(" "), _c('span', [_vm._v("Listings")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "statusbox"
  }, [_c('h2', [_vm._v("Businesses")]), _vm._v(" "), _c('div', {
    staticClass: "statusbox-content"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "business-listings"
    }
  }, [_c('strong', [_vm._v("view")]), _vm._v(" "), _c('span', [_vm._v("Listings")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-6"
  }, [_c('h3', [_vm._v("Activities")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "statusbox"
  }, [_c('h2', [_vm._v("Contracts")]), _vm._v(" "), _c('div', {
    staticClass: "statusbox-content"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "contracts"
    }
  }, [_c('strong', [_vm._v("view")]), _vm._v(" "), _c('span', [_vm._v("Listings")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "statusbox"
  }, [_c('h2', {
    staticStyle: {
      "text-transform": "inherit"
    }
  }, [_vm._v("CNsurveys")]), _vm._v(" "), _c('div', {
    staticClass: "statusbox-content"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "survey-requests"
    }
  }, [_c('strong', [_vm._v("view")]), _vm._v(" "), _c('span', [_vm._v("Listings")])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78384e80"}!./src/components/Dashboard/template.html
// module id = 307
// module chunks = 0